module.exports = __webpack_public_path__ + "static/img/14003005.8f8a1d33.png";